import { render, staticRenderFns } from "./BulkSubmit.vue?vue&type=template&id=3ff5f6d0&"
import script from "./BulkSubmit.vue?vue&type=script&lang=js&"
export * from "./BulkSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports